module.exports = __webpack_public_path__ + "static/img/PC-6.99a0c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-6.png
// module id = 2aoF
// module chunks = 0